import { axiosInstance } from '../utils/axios';

export const getRoles = extraData => axiosInstance.get('/roles', extraData);
